import * as React from 'react';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';
import { ICartItem } from '../../../../common/interfaces/search';
import { MakeModel } from '../../../../common/helpers/makeModel';
import { ItemThumb } from '.';
import { StringMethod } from '../../../../common/helpers/string';
import { unformat, toFixed } from 'accounting';
import { computed } from 'mobx';
import { Button, EButtonType } from '../action';
import { IOrderItem } from '../../../../common/interfaces/order';

// Styles
const s = require('./OrderItem.css');
const plusGreyIcon = require('./../../assets/plus-grey-icon.svg');

// Props
interface IOrderItemProps extends IOrderItem {}

// Component
@observer
export class OrderItem extends React.Component<IOrderItemProps, {}> {
    static get defaultProps(): IOrderItemProps {
        return {
            make: '',
            model: '',
            fromYear: null,
            toYear: null,
            image: null,
            id: 0,
            itemcode: '',
            customerItemcode: null,
            itemname: '',
            oem: '',
            partsLink: '',
            dpi: '',
            certification: '',
            quantity: null,
            price: null
        };
    }

    @computed private get formattedPrice(): { beforeDecimal: string; afterDecimal: string; } | null {
        if (this.props.price === null) {
            return null;
        }

        const exploded = toFixed(this.props.price, 2).split('.');

        if (exploded.length < 2) {
            return null;
        }

        return {
            beforeDecimal: exploded[0],
            afterDecimal: exploded[1]
        };
    }

    @computed private get formattedTotalPrice(): { beforeDecimal: string; afterDecimal: string; } | null {
        if (this.props.price === null || this.props.quantity === null) {
            return null;
        }

        const totalPrice = this.props.price * this.props.quantity;
        const exploded = toFixed(totalPrice, 2).split('.');

        if (exploded.length < 2) {
            return null;
        }

        return {
            beforeDecimal: exploded[0],
            afterDecimal: exploded[1]
        };
    }

    render() {
        return this.props.itemcode || this.props.customerItemcode ? (
            <div className={s.item}>

                <div className={s.details}>
                    <div className={s.image}>
                        <ItemThumb image={this.props.image} />
                    </div>
                    <div className={s.codename}>
                        <h4>
                            <img src={plusGreyIcon} alt="" />
                            <strong>{this.props.itemcode}</strong>
                            {this.props.customerItemcode && (
                                <span>/</span>
                            )}
                            {this.props.customerItemcode && (
                                <em>{this.props.customerItemcode}</em>
                            )}
                        </h4>
                        <p>
                            {StringMethod.removeUnwantedCharactersFromEnd(
                                this.props.itemname,
                                [',', ';', ':']
                            )}
                        </p>
                    </div>
                </div>

                <div className={s.part}>
                    <table>
                        <tbody>
                            <tr>
                                <td><p>OEM: <strong>{this.props.oem || 'N/A'}</strong></p></td>
                                <td><p>DPI: <strong>{this.props.dpi || 'N/A'}</strong></p></td>
                            </tr>
                            <tr>
                                <td><p>PARTSLINK: <strong>{this.props.partsLink || 'N/A'}</strong></p></td>
                                <td><p>CERT: <strong>{this.props.certification || 'N/A'}</strong></p></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={s.price}>
                    <p>

                        <em>Qty:</em>

                        {this.props.quantity !== null && (
                            <strong>{this.props.quantity}</strong>
                        )}

                        {this.props.quantity !== null && this.props.price !== null && (
                            <span> x </span>
                        )}

                        {this.props.price !== null && (
                            <span>$</span>
                        )}

                        {this.props.price !== null && (
                            <strong>{
                                this.formattedPrice !== null
                                    ? this.formattedPrice.beforeDecimal
                                    : '0'
                            }</strong>
                        )}

                        {this.props.price !== null && (
                            <span>.{
                                this.formattedPrice !== null
                                    ? this.formattedPrice.afterDecimal
                                    : '00'
                            }</span>
                        )}

                    </p>

                    <p>
                        <em>Total:</em>

                        <span>$</span>

                        <strong>{
                            this.formattedTotalPrice !== null
                                ? this.formattedTotalPrice.beforeDecimal
                                : this.formattedPrice !== null
                                    ? this.formattedPrice.beforeDecimal
                                    : '0'
                        }</strong>

                        <span>.{
                            this.formattedTotalPrice !== null
                                ? this.formattedTotalPrice.afterDecimal
                                : this.formattedPrice !== null
                                    ? this.formattedPrice.afterDecimal
                                    : '00'
                        }</span>
                    </p>
                </div>

            </div>
        ) : null;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/item/OrderItem.tsx